<template>
  <ControlWrapper
    v-bind="control.controlWrapper.value"
    :styles="control.styles"
    :is-focused="control.isFocused"
    :applied-options="control.appliedOptions"
    :error="control.control.value.errors"
  >
  </ControlWrapper>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import type { ControlElement } from '@jsonforms/core';
  import { rendererProps, useJsonFormsControl } from '@jsonforms/vue';
  import ControlWrapper from './ControlWrapper.vue';
  import { useWidgetControl } from '../util';
  import { config } from 'src/utils/config';

  const props = defineProps(rendererProps<ControlElement>());

  const control = useWidgetControl(useJsonFormsControl(props));

  onMounted(() => {
    control.onChange(config.value.context);
  });
</script>

<style scoped></style>
